import get from 'lodash/get'
import { siteId, siteIds } from '@/utils'
import { defaultState } from '@/dashboard/store/state'

// Only fetch once an hour, same as campaigns
let fetchCompleted = 0
const needsFetch = () => {
	const timePassed = new Date().getTime() - fetchCompleted
	const HOUR = 60 * 60 * 1000

	return timePassed > HOUR
}
export default {
	fetch ({ commit, state, dispatch, rootGetters }, payload = {}) {
		return new Promise((resolve, reject) => {
			// Run only if it has been over 2 hours, it is not yet connected, or
			// we are passing in a filter and need to update the data
			if ((!needsFetch() || !rootGetters.connected) && !payload.filter) {
				return resolve()
			}

			let params = []
			let query = ''
			let promise1 = Promise.resolve()

			commit('loading', 'accountDash', { root: true })

			params.push(`site=${siteIds ? siteIds.join(',') : siteId}`)

			// @todo: figure out how to ensure cache is busted in other ways.
			params.push(`t=${new Date().getTime()}`)

			if (payload.filter) {
				params.push(`filter=${payload.filter}`)

				if (payload.start) {
					params.push(`start=${this._vm.$moment(payload.start).format('YYYY-MM-DD')}`)
				}

				if (payload.end) {
					params.push(`end=${this._vm.$moment(payload.end).format('YYYY-MM-DD')}`)
				}
			} else {
				params.push('filter=30-days')
				params.push(`start=${this._vm.$moment().subtract(29, 'days').format('YYYY-MM-DD')}`)
				params.push(`end=${this._vm.$moment().format('YYYY-MM-DD')}`)
			}
			if (params.length) {
				query = `?${params.join('&')}`
			}

			if (rootGetters.shouldFetchUser) {
				promise1 = dispatch('fetchMe', {}, { root: true })
					.catch(error => {
						console.error({ error })
						return reject(error)
					})
			}

			const promise2 = new Promise((resolve, reject) => {
				this._vm.$api
					.get(`account-dashboard${query}`, { cached: false })
					.then(({ body }) =>  {
						commit('doneLoading', 'accountDash', { root: true })

						const stats = get(body, 'widgets.analytics.range1', defaultState()['analytics'])
						commit('setAnalyticsData', stats)

						const topCampaigns = get(body, 'widgets.top-campaigns', defaultState()['topCampaigns'])
						commit('setTopCampaigns', topCampaigns)
					})
			})

			Promise.all([ promise1, promise2 ])
				.then(() => {
					resolve()
				})
				.catch(error => {
					reject(error)
					console.error(error)
				})
		})
	},
}
